import { render } from "./MonochromePieChart.vue?vue&type=template&id=556c75dc"
import script from "./MonochromePieChart.vue?vue&type=script&lang=js"
export * from "./MonochromePieChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__